import Head from 'next/head'
import { memo } from 'react'

// Component that generates the header metadata for google to index the job offer
const JobOfferGoogleHeader = ({ jobOffer }) => {
  const { name, publishDate, description } = jobOffer

  const addJobOfferJsonLd = () => ({
    __html: `
    {
      "@context": "https://schema.org/",
      "@type": "JobPosting",
      "title": "${name}",
      "description": "<p>${description}</p>",
      "datePosted": "${new Date(publishDate).toISOString()}",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "Celtiberian Solutions",
        "sameAs": "https://celtiberian.es/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Granada",
          "addressRegion": "Granada",
          "addressCountry": "ES"
        }
      },
      "applicantLocationRequirements": {
        "@type": "Country",
        "name": "ES"
      },
      "jobLocationType": "TELECOMMUTE",
      "employmentType": "FULL_TIME"
    }
  `
  })

  return (
    <Head>
      <title>{name}</title>
      <meta name="description" content={description} key="desc" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addJobOfferJsonLd()}
        key="job-offer-jsonld"
      />
    </Head>
  )
}

export default memo(JobOfferGoogleHeader)
